import { useState, useMemo } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useWindowSize } from 'react-use';

import SlideToggle from './SlideToggle';
import { useRoutes } from '../api';

import './Header.sass';
import logo from '../assets/header/logo.png';
import slogan from '../assets/header/slogan.png';

const Header = () => {
	const [mobileMenuStatus, setMobileMenuStatus] = useState('');
	const { routes } = useRoutes();
	const { width } = useWindowSize();

	const toggleMobileMenuStatus = () => {
		setMobileMenuStatus(mobileMenuStatus ? '' : 'active');
	};

	const close = () => {
		setMobileMenuStatus('');
	};

	const location = useLocation();

	const isETFLandingPage = location.pathname === '/ETFlandingpage';

	const ETFLandingPageRoute = useMemo(() => {
		return routes?.find((route) => route.route === '/ETFlandingpage');
	}, [routes]);

	const notETFLandingPageRoutes = useMemo(() => {
		if (width < 1024) {
			return routes?.filter((route) => route.showm);
		}

		return routes?.filter((route) => route.show);
	}, [routes, width]);

	return (
		<header className='Header'>
			<div className='top'>
				<div className='left'>
					<Link to='/' onClick={close}>
						<img src={logo} alt='UOB Asset Management 大華銀投信' />
					</Link>

					{isETFLandingPage && (
						<div className='etfLandingTitle'>ETF專區</div>
					)}
				</div>

				<div className='right'>
					{isETFLandingPage ? (
						<div className='links'>
							<Link to='/'>回官網首頁</Link>
						</div>
					) : (
						<div className='links'>
							<a href='https://www.uobgroup.com' target='_blank' rel='noreferrer noopener'>
								新加坡大華銀行集團
							</a>
							<a href='https://www.uobam.com.sg' target='_blank' rel='noreferrer noopener'>
								新加坡大華資產管理
							</a>
							<a href='https://www.uobgroup.com/other_uob_sites/index.html' target='_blank' rel='noreferrer noopener'>
								其他相關集團網站
							</a>
						</div>
					)}

					<div className='slogan'>
						<img src={slogan} alt='RIGHT BY YOU 大華銀行' />
					</div>
				</div>

				<div className={`mobile-menu ${mobileMenuStatus}`} onClick={toggleMobileMenuStatus}></div>
			</div>

			<div className={`facade ${mobileMenuStatus}`} onClick={close}></div>

			<nav className={`bot ${mobileMenuStatus}`}>
				<Link to='/' className='landing' onClick={close}>
					首頁
				</Link>

				{!isETFLandingPage && notETFLandingPageRoutes?.map((route) => {
					if (route.url === '/' || route.route === '/') return null;

					const { guid, name, categoryChild } = route;

					const itemWidth = width < 1024 ? '100%' : Math.round(100 / (notETFLandingPageRoutes.length - 1)) + '%';

					return (
						<div className='nav-group' style={{ width: itemWidth }} key={guid}>
							<SlideToggle
								slideController={
									!route.categoryChild.length ? (
										<Link to='/dividend' className='nav-heading' onClick={close}>
											<div className='text'>{name}</div>
										</Link>
									) : (
										route.route === '/ETFlandingpage' ? (
											<Link to='/ETFlandingpage' className='nav-heading' onClick={close}>
												<div className='text'>{name}</div>
											</Link>
										) : (
											<div className='nav-heading'>
												<div className='text'>{name}</div>
												<div className='angle'></div>
											</div>
										)
									)
								}
								slideTarget={
									<div className='navs'>
										{categoryChild?.map((child) => {
											let responsive = '';

											if (child.show && !child.showm) responsive = 'l';

											if (!child.show && child.showm) responsive = 'm';

											if (!child.show && !child.showm) return null;

											return (
												<Link to={child.url || child.route} onClick={close} key={child.guid} className={responsive}>
													{child.name}
												</Link>
											);
										})}
									</div>
								}
							/>
						</div>
					);
				})}

				{isETFLandingPage && ETFLandingPageRoute?.categoryChild?.map((route) => {
					const { guid, url, name } = route;

					const itemWidth = width < 1024 ? '100%' : Math.round(100 / (routes.length - 1)) + '%';

					return (
						<div className='nav-group' style={{ width: itemWidth }} key={guid}>
							<SlideToggle
								slideController={
									<Link to={url || route.route} className='nav-heading' onClick={close}>
										{name}
									</Link>
								}
								slideTarget={
									<div className='navs'>
									</div>
								}
							/>
						</div>
					);
				})}

				<div className='mobile-links'>
					<div className='link-wrap'>
						<a href='https://www.uobgroup.com' target='_blank' rel='noreferrer noopener'>
							新加坡大華銀行集團
						</a>
					</div>

					<div className='link-wrap'>
						<a href='https://www.uobam.com.sg' target='_blank' rel='noreferrer noopener'>
							新加坡大華資產管理
						</a>
					</div>

					<div className='link-wrap'>
						<a href='https://www.uobgroup.com/other_uob_sites/index.html' target='_blank' rel='noreferrer noopener'>
							其他相關集團網站
						</a>
					</div>
				</div>
			</nav>
		</header>
	);
};

export default Header;
